<template>
  <a-typography-title
    v-bind="attrs"
    :class="[bem.b(), bem.is(level >= 6 ? 'text' : '')]"
    :level="level >= 6 ? 5 : level"
    :ellipsis="ellipsis"
  >
    <template v-for="item in Object.keys($slots)" #[item]="data">
      <slot :name="item" v-bind="data || {}"></slot>
    </template>
  </a-typography-title>
</template>

<script setup lang="ts">
import { createNamespace } from '@ll-plus/utils'
import { computed, useAttrs } from 'vue'

import { textProps } from './text'

// 1.defineOptions
defineOptions({ name: 'LlText' })

// 2.props
const props = defineProps(textProps)
const attrs = useAttrs()

// 3.computes/const
const bem = createNamespace('text')

const ellipsis = computed(() => {
  // 自定义传入对象配置
  if (attrs.ellipsis) {
    return attrs.ellipsis
  } else {
    return props.isEllipsis
      ? {
          rows: props.rows,
          tooltip: props.showTooltip,
          expandable: props.expandable,
          symbol: props.symbol || 'more',
        }
      : false
  }
})
</script>
